export interface CommonSharedByType {
  id: number;
  first_name: string;
  last_name: string | null;
  profile_image: string | null;
}

export const mapCommonSharedByType = (data: any): CommonSharedByType => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: CommonSharedByType = {
    id: data.id,
    first_name: data.first_name,
    last_name: data.last_name || null,
    profile_image: data.profile_image || null,
  };
  return res;
};

export const mapCommonSharedByTypes = (data: any[]): CommonSharedByType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapCommonSharedByType);
};
